/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconArrowRightBar = createReactComponent("arrow-right-bar", "IconArrowRightBar", [
  ["path", { d: "M18 15l3 -3l-3 -3", key: "svg-0" }],
  ["path", { d: "M3 12h18", key: "svg-1" }],
  ["path", { d: "M3 9v6", key: "svg-2" }]
]);

export { IconArrowRightBar as default };
//# sourceMappingURL=IconArrowRightBar.js.map
